import React from 'react';
import Breadcrumbs, { BreadcrumbItem } from '@westwing/ui-kit/Breadcrumbs';
import HybridLink from 'Client/components/Generic/Links/HybridLink';
import useBellaTranslator from 'Client/hooks/useTranslator';

interface LooksBreadcrumbsProps {
    room?: string;
}

const LooksBreadcrumbs: React.FC<LooksBreadcrumbsProps> = ({ room }) => {
    const t = useBellaTranslator();

    const getItems = () => {
        const basic: BreadcrumbItem[] = [
            {
                tag: HybridLink,
                name: 'Home',
                props: {
                    to: '/',
                },
            },
            {
                tag: HybridLink,
                name: t('Shop the Look'),
                props: {
                    to: room ? '/looks' : undefined,
                },
            },
        ];

        if (!room) {
            return basic;
        }

        return [...basic, { name: room }];
    };

    return <Breadcrumbs items={getItems()} />;
};

export default LooksBreadcrumbs;
